export const uploadAreaSx = {

  minHeight:180,

  border:"2px dashed #cbd5e1",

  borderRadius:"16px",

  backgroundColor:"#f8fafc",

  display:"flex",

  justifyContent:"center",

  alignItems:"center",

  flexDirection:"column",

  cursor:"pointer",

  transition:"all .2s ease",


  "&:hover":{

    borderColor:"#00c7db",

    backgroundColor:"#f0fdff"

  }

};



export const fileContainerSx = {

  width:"100%",

  display:"flex",

  alignItems:"center",

  padding:"20px",

};